import React from 'react'
import Banner from '../../assets/images/banner.jpg'
import { Helmet } from 'react-helmet-async'

const Home = () => {
  return (
    <div className='Home' id='home'>
      <Helmet>
        <title>NEOVERA SURVEYING CORPORATION | Measured by Accuracy, Driven by Integrity</title>
        <meta
          name="description"
          content="NEOVERA SURVEYING CORPORATION delivers professional and accurate mineral ore sampling, inspection, and surveying services for global trade and mining industries."
        />
        <link rel="canonical" href="https://neoveracsc.com/#home" />
      </Helmet>

      <img src={Banner} alt='Banner' />
      <div className='header'>
        <h3>Measured by Accuracy, Driven by Integrity</h3>
      </div>
    </div>
  )
}

export default Home
